module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hqtGS"))).then(() => module.bundle.root('d181N'));